import React from 'react';
import { SortableElement } from 'react-sortable-hoc';
import './Model.css';
import { cloudImg } from '../../general';

const SortableItem = SortableElement(({ image }) => (
  <div className="modelpage_model">
    <img className="modelpage_model_img" src={cloudImg(image.thumb.crop_2)} alt={cloudImg(image.thumb.crop_2)} />
  </div>
));

export default SortableItem;
